module.exports = __webpack_public_path__ + "img/total_installed_capacity_per_country.1809b93d.png";